import { useEffect } from "react"
import { useLocation, useNavigate } from "react-router-dom"
import { IS_NATIVE_APP } from "./config/appTarget.js"
import { useOnboarding } from "./hooks/useOnboarding.js"

/** iOS only: guards the carousel and handles deep-link first-opens. */
function OnboardingGuard() {
  const location = useLocation()
  const navigate = useNavigate()
  const { completed, loading, markCompleted } = useOnboarding()

  useEffect(() => {
    if (!IS_NATIVE_APP || loading) return

    if (!completed) {
      const isDeepLink =
        location.pathname !== "/" && location.pathname !== "/onboarding"
      if (isDeepLink) {
        // Deep-link first open — mark onboarding seen but keep user on target path.
        markCompleted()
      } else if (location.pathname !== "/onboarding") {
        navigate("/onboarding", { replace: true })
      }
    }
  }, [completed, loading, location.pathname, navigate, markCompleted])

  return null
}

export default OnboardingGuard
